<template>
    <div ref="root"></div>
</template>

<script>
import client from '../../common/client';
import { thumbnail } from '../../common/thumbnail';

export default {
    props: {
        filterSelector: {
            type: String,
            required: false,
            default: '#filter',
        },
        selectCategoryId: {
            type: Number,
            required: false,
            default: null,
        },
        visibleCategories: {
            type: Number,
            required: false,
            default: 6,
        },
        productsCategories: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            isCreated: false,
            isLoading: false,
            categories: [],
            selectedCategoryId: this.selectCategoryId,
            selectedCategory: null,
            forceSiblingsView: false,
            showAllCategories: false,
            actualView: 'children',
            parent: null
        };
    },
    mounted() {
        this.fetchCategories().then(() => {
            this.isCreated = true;
        });
    },
    methods: {
        fetchCategories() {
            let data = {
                select: this.forceSiblingsView ? 'siblings' : 'children',
            };

            if (this.selectedCategoryId) {
                data.category_id = this.selectedCategoryId;
            }

            if (this.productsCategories.length) {
                data.products_categories = this.productsCategories;
            }

            this.isLoading = true;
            return client
                .post('/catalog/get-categories-tree', data)
                .then((response) => {
                    // selected category doesnt have any subcategories
                    if (response.data.categories.length > 0) {
                        this.categories = response.data.categories;
                    }

                    this.selectedCategory = response.data.selected_category;
                    document.querySelector(this.filterSelector).dispatchEvent(
                        new CustomEvent('category.updated', {
                            detail: {
                                category: response.data.selected_category,
                            },
                        })
                    );

                    this.isLoading = false;
                    this.forceSiblingsView = false;
                    this.actualView = response.data.view;
                    this.parent = response.data.parent
                });
        },
        change(categoryId) {
            this.selectedCategoryId = categoryId;
            document.querySelector(this.filterSelector).dispatchEvent(
                new CustomEvent('category.changed', {
                    detail: {
                        category_id: this.selectedCategoryId,
                    },
                })
            );

            this.fetchCategories();
        },
        back() {
            // no category is selected
            if (!this.selectedCategoryId || this.selectedCategory === null) {
                return false;
            }

            this.forceSiblingsView = true;
            if (
                this.actualView == 'children' &&
                this.selectedCategory.parent_id !== null
            ) {
                this.forceSiblingsView = false;
            }

            this.change(this.selectedCategory.parent_id);
        },
        thumbnail(src, format) {
            return thumbnail(src, format);
        },
    },
    computed: {
        showBackButton() {
            // no category is selected
            if (!this.selectedCategoryId || this.selectedCategory === null) {
                return false;
            }

            // selected root category & forced siblings view
            if (
                this.selectedCategory.parent_id === null &&
                this.actualView == 'siblings'
            ) {
                return false;
            }

            return true;
        },
    },
};
</script>